module.exports = __webpack_public_path__ + "img/Porto Apartment - 15 of 85.f48f2ed8.jpeg";